module.exports = __webpack_public_path__ + "img/0-106.a592a27d.jpg";